'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React from 'react';

import cx from 'classnames';

import EntryLink from 'components/ui/Link/EntryLink';

import { SubNav } from './SubNav';
import { SubNavProvider, useSubNav } from './SubNavContext';

import SearchBar from '../SearchBar';

import styles from './Header.module.scss';

const HeaderDesktop = ({
    navigation,
    popularSearches,
    onSearchIsOpen,
    onActiveHoverChange,
}) => {
    return (
        <SubNavProvider onActiveHoverChange={onActiveHoverChange}>
            <div className={styles.desktopRoot}>
                <HeaderDesktopNav
                    navigation={navigation}
                    popularSearches={popularSearches}
                    onSearchIsOpen={onSearchIsOpen}
                />
            </div>
        </SubNavProvider>
    );
};

/**
 * Inner component that consumes SubNavContext.
 * Separated so the provider is above the consumer in the tree.
 */
const HeaderDesktopNav = ({ navigation, popularSearches, onSearchIsOpen }) => {
    const items = navigation.itemsCollection.items;
    const splitIdx = Math.ceil(items.length / 2);
    const linksLeft = items.slice(0, splitIdx);
    const linksRight = items.slice(splitIdx, items.length);

    const { activeHoverIndex, setActiveIndex } = useSubNav();

    const renderLinks = (items, navId) =>
        // These are the top-level nav items,
        // called twice:
        // 1. for left (navId === 'left')
        // 2. for right (navId === 'right') slots
        items.filter(Boolean).map((item, i) => {
            const id = `${navId}${i}`;
            const isActive = activeHoverIndex === id;
            const hasArrow = item.link.__typename === 'ExternalLink';
            const hasChevron =
                item.link.__typename === 'ManualLink' &&
                item.itemsCollection.items?.length > 0;
            // TODO: The `4` below is hardcoded, but it should be the length of linksLeft
            const delay = (navId === 'left' ? i : i + 4) * 60;
            return (
                <li
                    key={i}
                    style={{ '--delay': `${delay}ms` }}
                    className={cx(styles.navItem, {
                        [styles.hasChevron]: hasChevron,
                        [styles.hasArrow]: hasArrow,
                        [styles.isActive]: isActive,
                    })}
                    onMouseEnter={() => setActiveIndex(id)}
                    onMouseLeave={() => setActiveIndex(-1)}
                    onFocus={() => setActiveIndex(id)}
                    onBlur={e => {
                        if (!e.currentTarget.contains(e.relatedTarget)) {
                            setActiveIndex(-1);
                        }
                    }}
                >
                    <EntryLink entry={item.link} className={styles.linkLarge}>
                        <span className={styles.linkInner}>
                            {item.linkTitle}
                        </span>
                    </EntryLink>
                    {item.itemsCollection.items?.length > 0 && (
                        <div className={styles.subNavContainer}>
                            <div className={styles.subNavDrawer}>
                                <SubNav item={item} />
                            </div>
                        </div>
                    )}
                </li>
            );
        });

    return (
        <nav className={styles.nav}>
            <section className={styles.inner}>
                <div className={styles.linksWrapper}>
                    <ul className={styles.leftLinks}>
                        {renderLinks(linksLeft, 'left')}
                    </ul>
                    <ul className={styles.rightLinks}>
                        {renderLinks(linksRight, 'right')}
                    </ul>
                </div>
                <SearchBar
                    className={styles.searchBarDesktop}
                    onIsOpen={onSearchIsOpen}
                    popularSearchesMobileClassName={
                        styles.popularSearchesDesktopMobileInstance
                    }
                    popularSearches={popularSearches}
                />
            </section>
        </nav>
    );
};

export default HeaderDesktop;
